import * as React from 'react';
import { connect } from 'react-redux';
import LumiForm from '../../../../../common/components/LumiForm';
import LumiField from '../../../../../common/components/LumiField';
import LumiButton from '../../../../../common/components/LumiButton';
import ProgressSpinner from '../../../../../common/components/ProgressSpinner';
import { authenticate, resetCode, getDetails } from '../modules/actions';
import { Field } from 'redux-form';
import { required } from '../../../../../common/utils/validators';
import * as styles from './AuthView.scss';
import * as buttonStyle from '../../../../../common/sass/components/_button.scss';
import getUrlParamaterByName from '../../../../utils/auth';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
const formName = 'AuthForm';
import lumiEnvironment from '../../../../../lumi.environment';

type Props = {
  authenticate: (
    values: AuthFormValues,
    callback: Function,
    dispatch: Dispatch<any>,
    reset?: boolean,
    errorRoute?: string,
  ) => (dispatch: Dispatch<AuthResult>) => void;
  resetCode: () => void;
  getDetails: () => void;
  dispatch: any;
  phone: string;
  email: string;
  error: Err;
  isLoading: boolean;
  authenticated: true;
  location: {
    pathname: string;
    query: any;
    search: string;
  };
};

type Err = {
  message?: string;
};

type State = {
  codeRequested: boolean;
  resetToggle: boolean;
  email: string;
  phone: string;
};

export type AuthResult = {
  access_token: string;
  return_url: string;
};

// This is already defined in Props, why is it repeated here gahhh
type MapDispatchToProps = {
  authenticate: (
    values: AuthFormValues,
    callback: Function,
    dispatch: Dispatch<any>,
    reset?: boolean,
    errorRoute?: string,
  ) => (dispatch: Dispatch<AuthResult>) => void;
  resetCode: () => void;
  getDetails: (dispatch: Dispatch<any>) => void;
};

export type AuthFormValues = {
  code: string;
  access_token: string;
};

const mapDispatchToProps: MapDispatchToProps = {
  authenticate,
  resetCode,
  getDetails,
};

class AuthView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      codeRequested: false,
      resetToggle: false,
      phone: '',
      email: '',
    };
    this.initialAuth(props);
    this.resetClicked = this.resetClicked.bind(this);
    this.toggleReset = this.toggleReset.bind(this);
    this.codeRequested = this.codeRequested.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem(lumiEnvironment.LOCAL_STORAGE_NAME);
    const { dispatch } = this.props;
    dispatch(getDetails(dispatch));
  }

  submit = (form: AuthFormValues, dispatch: Dispatch<AuthResult>) => {
    const { authenticate } = this.props;
    const navigate = (authResult: AuthResult) => {
      const { access_token, return_url } = authResult;
      localStorage.setItem(lumiEnvironment.LOCAL_STORAGE_NAME, access_token);
      dispatch(push(`${return_url}`));
    };
    authenticate(form, navigate, dispatch);
  };

  async initialAuth(props: Props) {
    const { location } = props;
    const { code, authToken: token } = location.query;
    const { authenticate, dispatch } = props;
    const existingAccessToken = localStorage.getItem(
      lumiEnvironment.LOCAL_STORAGE_NAME,
    );
    if (code) {
      const navigate = (authResult: AuthResult) => {
        const { access_token, return_url } = authResult;
        localStorage.setItem(lumiEnvironment.LOCAL_STORAGE_NAME, access_token);
        dispatch(push(`${return_url}`));
      };
      await authenticate(
        { code, access_token: existingAccessToken },
        navigate,
        dispatch,
        true,
        `${location.pathname}${location.search}`,
      );
    }
  }

  toggleReset() {
    const { resetToggle } = this.state;
    this.setState({
      resetToggle: !resetToggle,
    });
  }

  codeRequested() {
    const { resetCode } = this.props;
    resetCode();
    this.setState({ codeRequested: true });
  }

  resetClicked() {
    const { resetCode } = this.props;
    resetCode();
    this.toggleReset();
  }

  render() {
    const { resetToggle, codeRequested } = this.state;
    const { phone, email, error, isLoading, authenticated } = this.props;

    let errorText;
    if (error && error.message) errorText = error.message;

    const resetInstructions = !resetToggle ? (
      <a onClick={this.resetClicked}>Click here.</a>
    ) : (
      <div>
        <h3>Sent!</h3>
        <p>Please check your inbox and enter the code above</p>
      </div>
    );

    const disclaimer = (
      <div className={styles.title}>
        <span>
          You can request an access code by clicking the button below.
        </span>
        <LumiButton
          className={styles.codeButton}
          label='Request code'
          onClick={this.codeRequested}
        />
      </div>
    );

    const help = <h4>Need a new code? </h4>;

    const phoneNumber = !!phone && <p>Phone: {phone}</p>;

    const emailAddress = !!email && <p>Email: {email}</p>;

    const title = <h1>Please log in</h1>;

    const description = (
      <div className={styles.title}>
        <span>We just need to make sure that this is you.</span>
        {!codeRequested && disclaimer}
        {emailAddress}
        {phoneNumber}
      </div>
    );
    const form = (
      <LumiForm
        name={formName}
        onSubmit={this.submit}
        warnUnsaved
        clientForm
        className={styles.authForm}
      >
        <Field
          className={styles.field}
          key={`${formName}-${name}`}
          name='code'
          type='text'
          label='Code'
          component={LumiField}
          validate={required}
          serverError={errorText}
        />
        <div className={styles.nextButton}>
          <LumiButton rounded phat label='Submit' type='submit' />
        </div>
      </LumiForm>
    );
    if (isLoading || authenticated) return <ProgressSpinner />;

    const body = (
      <React.Fragment>
        {form}
        {help}
        {resetInstructions}
      </React.Fragment>
    );

    return (
      <div className={styles.authCollection}>
        <div className={styles.authCollectionBox}>
          <div className={styles.title}>
            {title}
            {description}
          </div>
          {codeRequested && body}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    isLoading: state.user.isLoading,
    authenticated: state.user.authenticated,
    email: state.user.email,
    phone: state.user.phone,
    error: state.user.error,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthView);
